<template>
  <div>
    <Header />
    <div class="container">
      <template v-if="!show_order_success">
        <div class="text-center">
          <h2 class="current-pts">{{number_with_commas(cart.current_reward_points)}} Points Available</h2>
        </div>

        <div class="d-flex reward-detail-container">
          <img
            :src='selected_sku.photourl'
            :width="400"
          />
          <div class="ml-3">
            <h2>{{selected_sku.productname}}</h2>

            <ul v-for="(bullet_description, index) in selected_sku.description" :key="'bullet_description' + index">
              <li class="reward_description">{{bullet_description}}</li>
            </ul>

            <h3>{{number_with_commas(selected_sku.points)}} points each</h3>

            <div class="row total_block">
              <div class="quantity_select">
                <select class="form-control quantity_select" @change="changeQuantity($event)">
                  <option v-for="quantity in selected_sku.quantity_array" :value="quantity" :key="quantity">{{ quantity }}</option>
                </select>
              </div>
              <div class="total_points_text">
                {{number_with_commas(selected_sku.points * quantity)}} points total
              </div>
            </div>

          </div>
        </div>
        <h3 class="font-weight-normal mt-4">Please Enter Delivery Address:</h3>

        <table class="table reward-table">
          <tbody>
            <tr>
              <td>
                First Name
                <input
                    type="text"
                    id="firstname"
                    class="form-control"
                    :value="firstname"
                    @blur="firstname = $event.target.value"
                >
              </td>
              <td>
                Last Name
                <input
                    type="text"
                    id="lastname"
                    class="form-control"
                    :value="lastname"
                    @blur="lastname = $event.target.value"
                >
              </td>
              <td>
                Phone #
                <input
                    type="text"
                    id="phone"
                    class="form-control"
                    :value="phone"
                    @blur="phone = $event.target.value"
                >
              </td>
            </tr>
            <tr>
              <td>
                Address
                <input
                    type="text"
                    id="address"
                    class="form-control"
                    :value="address"
                    @blur="address = $event.target.value"
                >
              </td>
              <td>
                City
                <input
                    type="text"
                    id="city"
                    class="form-control"
                    :value="city"
                    @blur="city = $event.target.value"
                >
              </td>
              <td>
                Zip Code
                <input
                    type="text"
                    id="zipcode"
                    class="form-control"
                    :value="zipcode"
                    @blur="zipcode = $event.target.value"
                >
              </td>
              <td>
                State
                <input
                    type="text"
                    id="state"
                    class="form-control"
                    :value="state"
                    @blur="state = $event.target.value"
                >
              </td>
            </tr>
          </tbody>
        </table>

        <template v-if="not_enough_points" >
          <div class="not_enough_text">You don't have enough points to order this product.</div>
        </template>
        <template v-else>
          <button class="reward_btn my-5" v-on:click="place_reward_product_order()">Claim</button>
        </template>
      </template>
      <template v-else>
        <section class="section-b-space pb-0">
          <div class="text-center">
            <h2 class="current-pts mb-4">{{number_with_commas(remaining_points)}} Points Available</h2>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-md-12 p-0">
                <div class="success-text">
                  <h2><span>reward claimed</span> <img :src='"@/assets/images/subtract.svg"' class="ml-2" alt="check" width="56" /></h2>
                  <p>You will receive your reward in the mail in 2-3 business days! Thanks! </p>
                </div>
                <div class="text-right mr-md-5 mt-5">
                  <router-link class="btn delivery-btn delivery-small-btn router-link-active" to="/shop">Home</router-link>
                </div>
              </div>
            </div>
            <hr class="my-5" />
          </div>
        </section>
      </template>
    </div>
  </div>
</template>

<script>

import Header from "../components/header";

import {mapGetters} from "vuex";


export default {
  components: {
    Header
  },
  computed: {
    ...mapGetters({
      cart: 'cart/getCart',
      pages_products: 'cart/pages_products',
      reward_order_response: 'cart/reward_order_response',
    })
  },
  data() {
    return {
      reward_product: [],
      selected_sku: [],
      quantity: 1, // preparing for future use
      not_enough_points: false,
      show_order_success: false,
      order_button_enabled: false,
      firstname: "",
      lastname: "",
      address: "",
      city: "",
      zipcode: "",
      state: "",
      phone: "",
      remaining_points: "",
    };
  },
  mounted() {
    for(var i = 0; i < this.pages_products.rewards.length; i++) {
      if (this.sku === this.pages_products.rewards[i].sku) {
        this.selected_sku = this.pages_products.rewards[i];
      }
    }
    this.checkPoints(); // plus run if quantity changes in the future
  },
  props: {
    sku : null,
  },
  watch: {
    reward_order_response: async function() {
      this.show_order_success = true;
    },
    address: async function() {
      if(this.address && this.city && this.zipcode) {
        this.order_button_enabled = true;
      }
    },
    zipcode: async function() {
      if(this.address && this.city && this.zipcode) {
        this.order_button_enabled = true;
      }
    },
    city: async function() {
      if(this.address && this.city && this.zipcode) {
        this.order_button_enabled = true;
      }
    },
  },
  methods:{
    changeQuantity (event) {
      this.quantity = event.target.options[event.target.options.selectedIndex].value;
      this.checkPoints();
    },
    checkPoints() {
      this.not_enough_points = false;
      if(this.selected_sku) {
        this.remaining_points = this.cart.current_reward_points - (this.quantity * this.selected_sku.points);
        if (this.remaining_points < 0) {
          this.not_enough_points = true;
        }
      }
    },
    place_reward_product_order() {
      this.order_button_enabled = false;
      this.$store.dispatch('cart/placeRewardOrder', {quantity: this.quantity, sku: this.sku,
        firstname: this.firstname,lastname: this.lastname,address: this.address, city: this.city,zipcode: this.zipcode,state: this.state,phone: this.phone
      })
    },
    number_with_commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style scoped>
  .current-pts{
    font-size: 64px;
    margin: 60px auto;
    font-family: 'Inter';
    font-weight: 800;
    width: fit-content;
    border-bottom: 3px solid #000;
    padding: 0 50px 20px 50px;
  }

  .not_enough_text {
    color: red;
    font-size: 20px;
  }

  .quantity_select select {
    width:49px;
    font-size: 22px;
    margin-left: 12px;
  }

  .total_points_text {
    margin-top: 3px;
    margin-left: 15px;
    font-size: 26px;
    font-weight: 600;
  }

  .total_block {
    margin-top: 30px;
  }

  .reward_description {
    font-size: larger;
  }

</style>
